var map = {
	"./auth.js": "zvvS",
	"./guest.js": "m72D"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IGvS";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/router/middleware nonrecursive .*\.js$
// module id = IGvS
// module chunks = 0